<template>
  <div class="mb-4 border border-line rounded p-6 text-2sm text-text-ternary flex items-center">
    <component :is="goalMood.icon" class="mr-6 flex-none"/>
    <span class="break-all" v-html="goalMood.text"></span>
  </div>
</template>

<script>
import IconFaceSad from "@/components/icons/IconFaceSad";
import IconFaceConfusion from "@/components/icons/IconFaceConfusion";
import IconFaceHappy from "@/components/icons/IconFaceHappy";
import IconFaceConfusionGray from "@/components/icons/IconFaceConfusionGray";

export default {
  name: "GoalProgressTip",
  props: {
    summary: {
      type: Object
    },
    goal_type: {
      type: Number
    },
    account_title: {
      type: String,
    }
  },
  computed: {
    goalMood() {
      let text, icon;
      let date = this.computeMoodDate(this.summary.widget.date_end),
          tipText = `scenario.${this.summary.widget.scenario}`;
      text = this.$t(tipText, {date});

      icon = this.summary.color === 'green'
          ? IconFaceHappy
          : this.summary.color === 'yellow'
              ? IconFaceConfusion
              : IconFaceSad;

      if (this.summary.widget.scenario === 1) {
        icon = this.summary.color === 'green' ? IconFaceHappy : IconFaceConfusionGray;
        text = this.$t(tipText, {account_title: this.account_title});
      }
      return {icon, text}
    }
  },
  methods: {
    computeMoodDate(predictedDate) {
      let monthRuLabels = ',январе,феврале,марте,апреле,мае,июне,июле,августе,сентябре,октябре,ноябре,декабре'.split(','),
          date;
      if (this.$i18n.locale === 'ru') {
        let monthIndex = this.$moment.unix(predictedDate).format('M'),
            monthYear = this.$moment.unix(predictedDate).format('YYYY');
        date = `${monthRuLabels[monthIndex]} ${monthYear}`
      } else {
        date = this.$moment.unix(predictedDate).format('MMMM YYYY').toLowerCase()
      }
      return date
    }
  },
  i18n: {
    messages: {
      en: {
        scenario: {
          1: 'Fund «{account_title}» and track your progress.',
          2: '<span class="font-bold"> Going well: </span> at this pace you will reach your goal already at {date}.',
          3: 'You are moving well on schedule.',
          4: '<span class="font-bold"> Behind schedule: </span> at this pace you will only reach your goal at {date}.',
          5: 'You made your last payment more than a month ago, but if you return to the previous rate, you will reach your goal by {date}.',
          6: 'You made your last payment more than a month ago, but you are still meeting your savings plan.',
          7: '<span class="font-bold"> You made your last payment more than a month ago and you are not fulfilling your plan: </span> at this rate you will only reach your goal at {date}.',
          8: 'You made the last payment more than two months ago, but if you return to the previous rate, you will reach your goal by {date}.',
          9: 'You made your last payment more than two months ago, but you are still meeting your savings plan.',
          10: '<span class="font-bold"> You made your last payment more than two months ago and you are not fulfilling your plan: </span> at this rate you will only reach your goal at {date}.',
          11: '<span class="font-bold">Going well:</span> at this rate you will repay the loan already at {date}.',
          12: 'You are moving on schedule.',
          13: '<span class="font-bold">You are behind schedule:</span> at this rate you will only repay the loan at {date}.',
          14: 'You made the last payment more than a month ago, but if you return to the previous rate, then repay the loan already at {date}.',
          15: 'You made your last payment more than a month ago, but you are still fulfilling your repayment plan.',
          16: '<span class="font-bold">You made the last payment more than a month ago and do not fulfill the plan:</span> at this rate you will only repay the loan on {date}.',
          17: 'You made the last payment more than two months ago, but if you return to the previous rate, you will repay the loan already at {date}.',
          18: 'You made your last payment more than two months ago, but you are still meeting your repayment plan.',
          19: '<span class="font-bold">You made the last payment more than two months ago and you are not fulfilling the plan:</span> at this rate you will only repay the loan on {date}.',
        },
      },
      ru: {
        scenario: {
          1: 'Пополняйте счет «{account_title}»  и следите за прогрессом.',
          2: '<span class="font-bold">Хорошо идете:</span> в таком темпе вы достигнете цели уже в {date} года.',
          3: 'Вы двигаетесь четко по графику.',
          4: '<span class="font-bold">Отстаете от графика:</span> в таком темпе вы достигнете цели только в {date} года.',
          5: 'Вы внесли последний платеж больше месяца назад, но если вернетесь к прежнему темпу, то достигнете цели уже в {date} года.',
          6: 'Вы внесли последний платеж больше месяца назад, но пока выполняете план по накоплениям.',
          7: '<span class="font-bold">Вы внесли последний платеж больше месяца назад и не выполняете план:</span> в таком темпе вы достигнете цели только в {date} года.',
          8: 'Вы внесли последний платеж больше двух месяцев назад, но если вернетесь к прежнему темпу, то достигнете цели уже в {date} года.',
          9: 'Вы внесли последний платеж больше двух месяцев назад, но пока выполняете план по накоплениям.',
          10: '<span class="font-bold">Вы внесли последний платеж больше двух месяцев назад и не выполняете план:</span> в таком темпе вы достигнете цели только в {date} года.',
          11: '<span class="font-bold">Хорошо идете:</span> в таком темпе вы погасите кредит уже в {date} года.',
          12: 'Вы двигаетесь четко по графику.',
          13: '<span class="font-bold">Отстаете от графика:</span> в таком темпе вы погасите кредит только в {date} года.',
          14: 'Вы внесли последний платеж больше месяца назад, но если вернетесь к прежнему темпу, то погасите кредит уже в {date} года.',
          15: 'Вы внесли последний платеж больше месяца назад, но пока выполняете план погашения.',
          16: '<span class="font-bold">Вы внесли последний платеж больше месяца назад и не выполняете план:</span> в таком темпе вы погасите кредит только в {date} года.',
          17: 'Вы внесли последний платеж больше двух месяцев назад, но если вернетесь к прежнему темпу, то погасите кредит уже в {date} года.',
          18: 'Вы внесли последний платеж больше двух месяцев назад, но пока выполняете план погашения.',
          19: '<span class="font-bold">Вы внесли последний платеж больше двух месяцев назад и не выполняете план:</span> в таком темпе вы погасите кредит только в {date} года.',
        },
      }
    }
  }
}
</script>

<style scoped>

</style>